import React from "react";

const AccordionSection = ({ title, count, isOpen, onToggle, badgeClass, headerExtra, children }) => {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden">
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between px-4 sm:px-6 py-6 bg-white hover:bg-slate-50 transition-colors text-left"
      >
        <div className="flex items-center gap-3">
          <span className="text-base font-bold text-slate-800">{title}</span>
          <span className={`px-2.5 py-0.5 rounded-full text-xs font-bold ${badgeClass}`}>
            {count}
          </span>
        </div>
        <div className="flex items-center gap-2 sm:gap-3">
          {headerExtra}
          <svg
            className={`h-5 w-5 text-slate-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? "rotate-180" : ""}`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      <div
        className="overflow-hidden transition-all duration-300 ease-in-out"
        style={{ maxHeight: isOpen ? "10000px" : "0px" }}
      >
        <div className="border-t border-slate-100">{children}</div>
      </div>
    </div>
  );
};

export default AccordionSection;
